<div class="status-icon">
    <mat-icon *ngIf="statusVariant.isSvg; else materialIcon" [class]="materialClasses"
        [svgIcon]="statusVariant.icon"></mat-icon>
    <ng-template #materialIcon>
        <mat-icon [class]="materialClasses" [fontIcon]="statusVariant.icon"></mat-icon>
    </ng-template>

</div>